/**
 * ViewGuidedTourButton — "View Guided Tour" (task page header; the model
 * creation wizard has none).
 *
 * An icon-only Spark tertiary button (black question-circle icon, grey
 * border — the same 36×36 shape as the Playground button beside it) that
 * restarts the page's walkthrough from its first mark. Spark shows the
 * "View Guided Tour" tooltip from the aria-label on hover / focus.
 *
 * Renders nothing when `walkthroughId` is unknown to the registry, so callers
 * can pass whatever page they are on without guarding.
 */
import React, { useCallback } from 'react';

import { Button, SparkIcon } from '@spark';

import { useWalkthrough } from '../useWalkthrough';
import { getWalkthrough } from '../registry';

import './ViewGuidedTourButton.css';

export const VIEW_GUIDED_TOUR_LABEL = 'View Guided Tour';

export default function ViewGuidedTourButton({ walkthroughId, className = '', onStart }) {
    const { start } = useWalkthrough();

    const handleClick = useCallback(() => {
        start(walkthroughId, { restart: true });
        onStart?.(walkthroughId);
    }, [onStart, start, walkthroughId]);

    if (!getWalkthrough(walkthroughId)) return null;

    return (
        <div
            className={['view-guided-tour', className].filter(Boolean).join(' ')}
            data-walkthrough-id={walkthroughId}
        >
            <Button
                variant="tertiary"
                size="medium"
                type="button"
                className="view-guided-tour__button fs-unmask"
                aria-label={VIEW_GUIDED_TOUR_LABEL}
                icon={<SparkIcon slug="circle-help" size="medium" />}
                onClick={handleClick}
            />
        </div>
    );
}
